import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./AuthContext";

const Ctx = createContext(null);

const DEFAULT_SELF = { id: "__self__", name: "Diri Sendiri", dob: null, age: 25, sex: "male", weight: 60, height: 165, activity: "sedang", notes: "" };

export function SubjectsProvider({ children }) {
  const { user } = useAuth();
  const [subjects, setSubjects] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem("gidza_active_subject") || "__self__");

  const load = useCallback(async () => {
    if (!user) { setSubjects([]); return; }
    try { const r = await api.get("/subjects"); setSubjects(r.data); } catch { }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => { localStorage.setItem("gidza_active_subject", activeId); }, [activeId]);

  const allSubjects = user ? [{ ...DEFAULT_SELF, name: user.full_name || "Diri Sendiri" }, ...subjects] : [DEFAULT_SELF];
  const active = allSubjects.find(s => s.id === activeId) || allSubjects[0];

  const create = async (data) => { const r = await api.post("/subjects", data); await load(); setActiveId(r.data.id); return r.data; };
  const update = async (id, data) => { const r = await api.put(`/subjects/${id}`, data); await load(); return r.data; };
  const remove = async (id) => { await api.delete(`/subjects/${id}`); if (activeId === id) setActiveId("__self__"); await load(); };

  return <Ctx.Provider value={{ subjects: allSubjects, active, activeId, setActiveId, create, update, remove, reload: load }}>{children}</Ctx.Provider>;
}

export const useSubjects = () => useContext(Ctx);
